var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: {
        "lc-section": true,
        "lc-section-main": _vm.section.isMain,
        "lc-section-base": !_vm.section.isMain,
      },
    },
    [
      !_vm.section.isMain
        ? _c(
            "div",
            [
              _vm.section.speaker && _vm.section.speaker.photo
                ? _c("ImgixImage", {
                    staticClass: "lc-section-photo",
                    attrs: {
                      image: _vm.section.speaker.photo,
                      width: 40,
                      height: 40,
                      alt: _vm.section.speaker.name,
                    },
                  })
                : _c("div", { staticClass: "lc-section-initials" }, [
                    _vm._v("\n      " + _vm._s(_vm.initials) + "\n    "),
                  ]),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "self-center" }, [
        _c(
          "div",
          { staticClass: "lc-section-title-row" },
          [
            _c("h3", { staticClass: "lc-section-title" }, [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n      "),
            ]),
            _vm._v(" "),
            _vm.isCurrent
              ? _c("Badge", { staticClass: "self-start" }, [
                  _c(
                    "svg",
                    {
                      attrs: {
                        xmlns: "http://www.w3.org/2000/svg",
                        height: "24",
                        viewBox: "0 0 24 24",
                        width: "24",
                      },
                    },
                    [
                      _c("path", {
                        attrs: { d: "M0 0h24v24H0z", fill: "none" },
                      }),
                      _vm._v(" "),
                      _c("path", {
                        attrs: {
                          d: "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z",
                        },
                      }),
                    ]
                  ),
                  _vm._v("\n\n        On\n      "),
                ])
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "lc-section-subtitle" }, [
          _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    "),
        ]),
      ]),
      _vm._v(" "),
      _vm.hasActions
        ? _c("div", { staticClass: "lc-section-actions" }, [
            _vm.canSeek
              ? _c(
                  "button",
                  {
                    staticClass: "lc-section-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("seek-to", _vm.section.start)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "16",
                          height: "16",
                          viewBox: "0 0 16 16",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M13.8 12.9999C13.8 13.3313 13.5314 13.5999 13.2 13.5999C12.8687 13.5999 12.6 13.3313 12.6 12.9999V2.9999C12.6 2.66853 12.8687 2.3999 13.2 2.3999C13.5314 2.3999 13.8 2.66853 13.8 2.9999V12.9999Z",
                            fill: "white",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M2.60003 12.479C2.60003 13.2777 3.49019 13.7541 4.15475 13.3111L10.8731 8.83218C11.4668 8.43634 11.4668 7.56387 10.8731 7.16805L4.15475 2.68916C3.49019 2.24613 2.60003 2.72251 2.60003 3.52121V12.479Z",
                            fill: "white",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.hasSpeakerInfo
              ? _c(
                  "button",
                  {
                    staticClass: "lc-section-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.isSpeakerInfoVisible = !_vm.isSpeakerInfoVisible
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "16",
                          height: "16",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "M12 1.999c5.524 0 10.002 4.478 10.002 10.002 0 5.523-4.478 10.001-10.002 10.001C6.476 22.002 2 17.524 2 12.001 1.999 6.477 6.476 1.999 12 1.999zm0 1.5a8.502 8.502 0 100 17.003A8.502 8.502 0 0012 3.5zm-.004 7a.75.75 0 01.744.648l.007.102.004 5.502a.75.75 0 01-1.494.102l-.006-.101-.004-5.502a.75.75 0 01.75-.75zm.005-3.497a.999.999 0 110 1.997.999.999 0 010-1.997z",
                          },
                        }),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isSpeakerInfoVisible
        ? _c("div", {
            staticClass:
              "lc-speaker-info col-span-2 content text-sm p-4 border-0 border-t border-solid border-gray-200",
            domProps: { innerHTML: _vm._s(_vm.section.speaker.info) },
          })
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }